export const domain = 'Cart';

// action types
export const CLEAR_UPDATE_MESSAGES = `${domain}/CLEAR_UPDATE_MESSAGES`;
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const IS_UPDATING = `${domain}/IS_UPDATING`;
export const RECEIVE_SHOPPING_CART = `${domain}/RECEIVE_SHOPPING_CART`;
export const RECEIVE_UPDATE_MESSAGES = `${domain}/RECEIVE_UPDATE_MESSAGES`;
export const RECEIVE_WISH_LIST = `${domain}/RECEIVE_WISH_LIST`;
export const UPDATE_ERROR = `${domain}/UPDATE_ERROR`;
export const SHOPPING_CART = 1;
export const WISH_LIST = 2;
export const IS_EMAILINGCART = `${domain}/IS_EMAILINGCART`;
export const EMAILINGCART_ERROR = `${domain}/EMAILINGCART_ERROR`;
export const RECEIVE_EMAILINGCART_MESSAGES = `${domain}/RECEIVE_EMAILINGCART_MESSAGES`;
export const CLEAR_EMAILCART_MESSAGES = `${domain}/CLEAR_EMAILCART_MESSAGES`;
